function Watch({ color }) {
    return (
<svg width="30px" height="30px" viewBox="0 0 100 100" version="1.1">
    <g id="8.-File-empty" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
        <g transform="translate(12.000000, 2.000000)" stroke="black" stroke-width="2">
            <polygon id="Layer-1" points="57.37875 0 0 0 2.59304094e-07 96 76.8 96 76.8 19.3940625 76.6056655 19.2 57.6 0.220940276"></polygon>
            <polyline id="Layer-2" points="74.88 21.12 55.68 21.12 55.68 1.92"></polyline>
        </g>
    </g>
</svg>
    );
}

export default Watch;
